import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IProductExcelUploadRequest {
  files: File[];
}

async function productExcelUpload(formData: FormData): Promise<any> {
  try {
    return (await axiosInstance.post("/Product/AddProductWithExcel", formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useAddProductWithExcel() {
  return useMutation<any, Error, FormData>(
    (variables) => productExcelUpload(variables)
  );
}
